import { render } from "./DuplicateAction.vue?vue&type=template&id=13c7fe7a"
import script from "./DuplicateAction.vue?vue&type=script&lang=ts"
export * from "./DuplicateAction.vue?vue&type=script&lang=ts"
script.render = render

export default script